var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('v-col', {
    staticClass: "p-0 d-flex flex-column justify-content-center align-items-center",
    attrs: {
      "lg": "5",
      "xl": "5",
      "md": "6",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-content",
    class: _vm.textContentStyle
  }, [_c('div', {
    staticClass: "title-text py-3",
    class: _vm.titleTextStyle
  }, [_vm._v(" Pillars of Knowledge ")]), _c('div', {
    staticClass: "sub-title-text",
    class: _vm.subTitleTextStyle
  }, [_vm._v(" View Project Spectrum’s 8 Courses to learn more about how to keep your business Cyber Secure ")])])]), _c('v-col', {
    staticClass: "p-0 d-flex flex-row justify-content-center align-items-center",
    style: {
      marginTop: _vm.topMarginSize
    },
    attrs: {
      "lg": "7",
      "xl": "7",
      "md": "6",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "action-handler-items"
  }, _vm._l(_vm.actionHandlerItems, function (actionItem) {
    return _c('div', {
      key: actionItem.actionTitle,
      staticClass: "action-handler-item d-flex flex-row align-items-center justify-content-center justify-content-lg-start justify-content-xl-start",
      style: {
        width: _vm.actionItemSize
      }
    }, [_c('v-btn', {
      style: {
        fontSize: _vm.actionItemFontSize
      },
      attrs: {
        "rounded": "",
        "large": "",
        "dark": "",
        "color": '#424EC4',
        "width": _vm.actionItemWidth
      },
      on: {
        "click": function ($event) {
          return _vm.openCourseActionItemHandler(actionItem.actionTitle, actionItem.actionUrl);
        }
      }
    }, [_vm._v(" " + _vm._s(actionItem.actionTitle) + " ")])], 1);
  }), 0)])], 1), _c('section', {
    staticClass: "mt-5",
    attrs: {
      "id": "blueprint-options-list-container"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex flex-column justify-content-start w-100"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-center section-title w-100"
  }, [_c('span', {
    staticClass: "m-0"
  }, [_vm._v("VIDEO LIBRARY")])]), _c('div', {
    staticClass: "d-flex flex-row justify-content-center w-100"
  }, [_c('span', {
    staticClass: "project-spectrum-title m-0 text-center"
  }, [_vm._v("View all videos discussing")])]), _c('div', {
    staticClass: "d-flex flex-row justify-content-center w-100"
  }, [_c('span', {
    staticClass: "project-spectrum-title m-0 text-center"
  }, [_vm._v("our Pillars of Knowledge")])]), _c('div', {
    staticClass: "blueprint-options d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column justify-content-center",
    class: {
      'align-items-center': !_vm.isVideoTypeItemsOpened,
      'align-items-lg-start align-items-xl-start align-items-sm-center align-items-center': _vm.isVideoTypeItemsOpened
    }
  }, [_c('div', {
    staticClass: "blueprint-option-title",
    class: {
      'mb-2': !_vm.isVideoTypeItemsOpened,
      'mt-3': _vm.isVideoTypeItemsOpened
    }
  }, [_vm._v(" " + _vm._s(!_vm.videoTypeItem ? "I am here because" : "I am here because I want to watch") + " ")]), _c('div', {
    staticClass: "blueprint-options-container",
    class: _vm.computeBlueoptionsLeftMargin,
    attrs: {
      "id": "blueprint-options-list"
    }
  }, [_c('div', {
    staticClass: "blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2",
    on: {
      "click": function ($event) {
        _vm.isVideoTypeItemsOpened = !_vm.isVideoTypeItemsOpened;
      }
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "p-0 d-flex justify-content-start align-items-center",
    attrs: {
      "cols": "11"
    }
  }, [_vm._v(" " + _vm._s(!_vm.videoTypeItem ? "Select an option" : `more on ${_vm.selectedVideoTypeItemValue}`) + " ")]), _c('v-col', {
    staticClass: "p-0 pr-1 d-flex justify-content-center",
    attrs: {
      "cols": "1"
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "max-width": "100% !important"
    },
    attrs: {
      "size": "2x",
      "icon": _vm.isVideoTypeItemsOpened ? 'chevron-up' : 'chevron-down'
    }
  })], 1)], 1)], 1)], 1), _vm._l(_vm.videoTypeOptionItems, function (option) {
    return _vm.isVideoTypeItemsOpened ? _c('div', {
      key: option.optionItem,
      staticClass: "blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2",
      class: {
        'selected-blueprint-option': option.optionItem === _vm.videoTypeItem
      },
      on: {
        "click": function ($event) {
          return _vm.setVideoTypeItemOption(option.optionItem);
        }
      }
    }, [_vm._v(" " + _vm._s(option.optionValue) + " ")]) : _vm._e();
  })], 2), _vm.videoTypeItem !== null ? _c('div', {
    staticClass: "d-flex flex-row justify-content-center align-items-center",
    class: _vm.computeBlueoptionsLeftMargin
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    },
    on: {
      "click": function ($event) {
        _vm.videoTypeItem = null;
      }
    }
  }, [_vm._v(" See All Videos ")])], 1) : _vm._e()])])])], 1)], 1)]), _c('section', {
    staticClass: "my-4"
  }), _c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "container p-3 compliance-container"
  }, [_c('div', {
    staticClass: "cmmc-compliance-check"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xl": "7",
      "lg": "7",
      "md": "7",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "compliance-text top-compliance-text d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_vm._v(" Check your CMMC Compliance Level ")]), _c('div', {
    staticClass: "compliance-text bottom-compliance-text d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start my-3"
  }, [_vm._v(" Take our cyber readiness assessment to determine how prepared your business is to deal with cyber-attacks. ")])]), _c('v-col', {
    staticClass: "d-flex flex-row align-items-center justify-content-center",
    attrs: {
      "xl": "5",
      "lg": "5",
      "md": "5",
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "color": '#fff',
      "width": "240",
      "height": "60"
    },
    on: {
      "click": _vm.goToTaskAssessment
    }
  }, [_vm._v(" Start Now ")])], 1)], 1)], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCourseContainer,
      expression: "showCourseContainer"
    }],
    staticClass: "course-container-overlay"
  }, [_c('div', {
    staticClass: "course-container-display",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "close-cource-container"
  }, [_c('button', {
    staticClass: "close-course-container-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.showCourseContainer = false;
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  })])]), _vm.showCircularLoader && _vm.selectedCourseUrl ? _c('div', {
    staticClass: "w-100 d-flex flex-column justify-content-center align-items-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "color": '#424EC4',
      "indeterminate": ""
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "500",
      "font-style": "normal",
      "color": "black",
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(`Loading the ${_vm.selectedCourseItem} course....`) + " ")])], 1) : _vm._e(), _vm.selectedCourseUrl ? _c('iframe', {
    staticClass: "course-content-iframe",
    attrs: {
      "id": "iframe-content",
      "src": _vm.selectedCourseUrl,
      "frameborder": "0"
    },
    on: {
      "load": function () {
        return _vm.iframeEndLoadHandler();
      }
    }
  }) : !_vm.selectedCourseUrl ? _c('span', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "700",
      "font-style": "normal",
      "color": "black",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(`The course for "${_vm.selectedCourseItem}" is yet to be provided`))]) : _vm._e()])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }